module.exports = __webpack_public_path__ + "media/images/temp/accordion-image-3-9f893f42b201a476e79648199ab5c03a.png";